module.exports = __webpack_public_path__ + "static/img/confetti.0038054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confetti.png
// module id = 679
// module chunks = 8